import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HrDevelopmentListComponent } from './hr-development-list/hr-development-list.component';
import { HrDevelopmentCreateComponent } from './hr-development-create/hr-development-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: HrDevelopmentListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: HrDevelopmentCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'hr-development-create/:id',
        component: HrDevelopmentCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HrDevelopmentRoutingModule { }
